<template>
    <v-row no-gutters>
        <v-col cols="12" sm="10" offset-sm="1">
            <v-row no-gutters class="pa-4">
                <v-col cols="12" sm="12" class="pa-2">
                    <span class="title">{{$t('settings.title')}}</span>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-select clearable
                            dense
                            :label="$t('settings.mainMenu')"
                            outlined
                            prepend-inner-icon="mdi-subdirectory-arrow-right"
                            :items="menu"
                            item-text="name"
                            item-value="id"
                            v-model="settings.main_menu_id"
                            return-object
                    ></v-select>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-select clearable
                            dense
                            :label="$t('settings.footerMenu')"
                            outlined
                            prepend-inner-icon="mdi-subdirectory-arrow-right"
                            :items="menu"
                            item-text="name"
                            item-value="id"
                            v-model="settings.footer_menu_id"
                            return-object
                    ></v-select>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="settings.phone"
                            dense
                            :label="$t('settings.phone')"
                            outlined
                            prepend-inner-icon="mdi-phone"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="settings.fax"
                            dense
                            :label="$t('settings.fax')"
                            outlined
                            prepend-inner-icon="mdi-phone-settings"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="settings.email"
                            dense
                            :label="$t('settings.email') + ' ' + 1"
                            outlined
                            prepend-inner-icon="mdi-email"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="settings.product_email"
                            dense
                            label="Order email"
                            outlined
                            prepend-inner-icon="mdi-email"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="settings.email1"
                            dense
                            :label="$t('settings.email') + ' ' + 2"
                            outlined
                            prepend-inner-icon="mdi-email"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="settings.email2"
                            dense
                            :label="$t('settings.email') + ' ' + 3"
                            outlined
                            prepend-inner-icon="mdi-email"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="settings.email3"
                            dense
                            :label="$t('settings.email') + ' ' + 4"
                            outlined
                            prepend-inner-icon="mdi-email"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="settings.address"
                            dense
                            :label="$t('settings.city')"
                            outlined
                            prepend-inner-icon="mdi-home-city"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="settings.city"
                            dense
                            :label="$t('settings.categoryId')"
                            outlined
                            prepend-inner-icon="mdi-subdirectory-arrow-right"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="settings.document_limit"
                            dense
                            :label="$t('settings.numDocument')"
                            outlined
                            prepend-inner-icon="mdi-subdirectory-arrow-right"
                    ></v-text-field>
                </v-col>

                <v-col class="d-flex mb-3" cols="12">
                    <v-divider></v-divider>
                </v-col>

                <v-col cols="12" class="px-2 mb-4">
                    <span class="title">Geo lokacija</span>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="settings.geo_lat"
                            dense
                            label="Longitude"
                            outlined
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="settings.geo_lng"
                            dense
                            label="Latitude"
                            outlined
                    ></v-text-field>
                </v-col>
                <div id="map-holder">
                    <div id="map"></div>
                </div>

                <v-col class="d-flex mt-3" cols="12">
                    <v-row justify="center">
                        <v-btn block color="secondary" dark @click="save">{{$t('settings.save')}}</v-btn>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
	import bitPage from "../../components/layout/page";

	export default {
		components: {
			bitPage
		},
		head() {
			return {
				title: 'BitLab CMS'
			}
		},
		data: () => ({
			breadcrumbs: [
				{
					text: 'Globalna podesavanja',
					disabled: true
				},
			],
			items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
			settings: {
				phone: null,
				fax: null,
				email: null,
				email1: null,
				email2: null,
				email3: null,
				address: null,
				city: null,
				document_limit: null,
        geo_lat: null,
        geo_lng: null
			},
			menu: [],
			marker: null,
			position: {lat: 44.771782971231794, lng: 17.195782475173473}
		}),
		created() {
			this.axios.get('/settings').then(res => {
        //this.settings = res.data[0]
        this.settings = {...this.settings, ...res.data[0]}
      });
			this.axios.get('/menu').then(res => this.menu = res.data)
		},
    methods: {
      save() {
        if(this.settings.id) {
          this.settings.main_menu_id = this.settings.main_menu_id ? this.settings.main_menu_id.id : 0
          this.settings.footer_menu_id = this.settings.footer_menu_id ? this.settings.footer_menu_id.id : 0
          this.axios.put(`/settings/` + this.settings.id, this.settings).then(res => {
              console.log(res)
          })
        }
        else {
          this.settings.main_menu_id = this.settings.main_menu_id ? this.settings.main_menu_id.id : 0
          this.settings.footer_menu_id = this.settings.footer_menu_id ? this.settings.footer_menu_id.id : 0
          this.axios.post(`/settings`, this.settings).then(res => {
              console.log(res)
          })
        }
      }
    },
		mounted() {
			this.map = new google.maps.Map(document.getElementById('map'), {
				center: this.position,
				zoom: 14
			});
			this.marker = new google.maps.Marker({position: this.position, map: this.map});
			let _this = this;
			google.maps.event.addListener(this.map, 'click', function (event) {
				_this.position = {lat: event.latLng.lat(), lng: event.latLng.lng()};
			});
		},
    watch: {
			position: {
				handler () {
					this.position.lat = Number(this.position.lat);
					this.position.lng = Number(this.position.lng);
					this.marker.setMap(null);
					this.marker = new google.maps.Marker({position: this.position, map: this.map});
      },
      deep: true
      }
    }
	}
</script>

<style>
    #map-holder {
        width: 100%;
        padding-top: 33%;
        overflow: hidden;
        position: relative;
    }

    #map {
        width: 100%;
        height: 100%;
        position: initial !important;
    }
</style>
